export class GiftCategory {
  name:string=""
  id:number=0

  formData(){
      let body = new URLSearchParams();
      body.set('name', this.name);
      body.set('id', this.id.toString());

      return body.toString()
    }

}
